import { useQuery } from '@tanstack/react-query';
import { getPlayersPriceRange, searchPlayers, type SearchPlayersParams } from '@/api/players';
import type { PlayersSearchResponse } from '@/types/players';

export function usePlayersSearch(params: SearchPlayersParams & { enabled?: boolean }) {
  const { query = '', position, team, limit = 40, offset = 0, sort = 'selected_by_percent.desc', enabled } = params;
  return useQuery<PlayersSearchResponse>({
    queryKey: ['players', 'search', { query, position, team, limit, offset, sort }],
    queryFn: () => searchPlayers({ query, position, team, limit, offset, sort }),
    enabled: enabled !== undefined ? enabled : !!(query || position || team),
    staleTime: 30 * 1000,
  });
}

export function usePlayersPriceRange() {
  return useQuery({
    queryKey: ['players', 'price-range'],
    queryFn: getPlayersPriceRange,
    staleTime: 60 * 1000, // API cache 60s
  });
}

